/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function() {


	var _lifeCycleManager = {

		init: function () {
			this._cycleEvents = {};
			this._invokedEvents = {};
		},

		/**
		 * Registers a LifeCycle callback
		 *
		 * @param {string} name - The name of the lifecycle hook provided by the dashboard
		 * @param {function} handler - The callback handler to be invoked
		 * @param {int} priority - The priority of the callback, higher numbers are executed first
		 *
		 */
		registerLifeCycleHandler: function (name, handler, priority, triggerIfEventAlreadySent) {
			if(typeof(handler) !== 'function') {
				throw new Error('Action for ' + name + ' must be a function');
			}
			// Number.isInteger() is part of ES6 and therefore not supported on IE 11
			if (priority && !(typeof priority === 'number' && isFinite(priority) && Math.floor(priority) === priority)) {
				throw new Error('Priority for ' + name + ' must be an integer');
			}
			this._createEvent(name);

			let action = {
				handler: handler,
				priority: priority || 0
			};
			this._cycleEvents[name].actions.push(action);

			let invokeCallPromise;
			if( triggerIfEventAlreadySent && this._invokedEvents[name] && this._invokedEvents[name].invoked ) {
				invokeCallPromise = action.handler.call(action.handler, this._invokedEvents[name].payload );
			}

			return {
				remove: function() {
					if(this._cycleEvents !== null && this._cycleEvents.hasOwnProperty(name)){
						this._cycleEvents[name].actions = this._cycleEvents[name].actions.filter((element) => { return element !== action; });
					}
				}.bind(this),
				invokeCallPromise: invokeCallPromise
			};
		},

		/**
		 * Invokes the LifeCycle callback handlers registered to the action
		 * @param {string} name - Name of the life cycle action to invoke
		 * @param {object} payload - Any data to pass to the action handlers
		 *
		 */
		invokeLifeCycleHandlers: function (name, payload) {
			return Promise.resolve()
				.then(function() {
					var promise = Promise.resolve();
					this._invokedEvents[name] = this._invokedEvents[name] || {};
					this._invokedEvents[name].invoked = true;
					this._invokedEvents[name].payload = payload;
					if(this._cycleEvents.hasOwnProperty(name)) {
						this._cycleEvents[name].actions.sort(function (a, b) {
							return  b.priority - a.priority;
						});
						this._cycleEvents[name].actions.forEach(function (action) {
							promise = promise.then(action.handler.bind(action.handler, payload));
						});
					}
					return promise;
				}.bind(this));
		},

		destroy: function () {
			this._cycleEvents = null;
		},

		_getCycleEvents: function () {
			return this._cycleEvents;
		},

		_createEvent: function (eventName) {
			if(!this._cycleEvents.hasOwnProperty(eventName)) {
				this._cycleEvents[eventName] = {
					actions: []
				};
			}
		}
	};

	function LifeCycleManager(options) {
		this.init(options);
	}

	Object.keys(_lifeCycleManager).forEach(function (key) {
		LifeCycleManager.prototype[key] = _lifeCycleManager[key];
	});

	return LifeCycleManager;
});
